import { gql } from '@apollo/client';

export const DELETE_REPORT_TEMPLATE = gql`
  mutation deleteReportTemplate($id: ID!) {
    reportTemplate: deleteReportTemplate(id: $id) {
      id
    }
  }
`;
